var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#212831",
  d: "m8.3 11.3 6-6c.2-.2.4-.3.7-.3s.5.1.7.3c.4.4.4 1 0 1.4L10.4 12l5.3 5.3c.4.4.4 1 0 1.4s-1 .4-1.4 0l-6-6c-.4-.4-.4-1 0-1.4"
})));
export default SvgChevronLeft;